@if (componentData$ | async; as data) {
  @if (data.uid !== 'CarlisleSalesHompageSplashBannerComponent') {
    <cx-generic-link
      [url]="!(isNacPage$ | async) ? data.urlLink : 'nac'"
      [target]="data.external == 'true' ? '_blank' : null"
      >
      @if (data.headline) {
        <p [innerHTML]="data.headline"></p>
      }
      <cx-media [container]="data.media"></cx-media>
      @if (data.content) {
        <p [innerHTML]="data.content"></p>
      }
    </cx-generic-link>
  }
}
